module.exports = __webpack_public_path__ + "static/media/modelo_gestion_cuadro1.da01bfe7.png";